import axios from "axios";
import { useAuth } from "@clerk/react";
import { useCallback } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchEvents = (params = {}) => axios.get(`${API}/events`, { params }).then((r) => r.data);
export const fetchEvent = (id) => axios.get(`${API}/events/${id}`).then((r) => r.data);

export function useAuthedApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, path, data) => {
      const token = await getToken();
      const res = await axios({ method, url: `${API}${path}`, data, headers: { Authorization: `Bearer ${token}` } });
      return res.data;
    },
    [getToken]
  );
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return "Verifique os campos obrigatórios";
  return d || "Algo deu errado. Tente novamente.";
};
